import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Base_ResolutionFunctionEditorPanel } from '../Base_ResolutionFunctionEditorPanel.js';
import './Panel_HcsVariables.scss';
import { ModuleFE_Variable } from '@app/hcs-frontend';
import { MUSTNeverHappenException } from '@nu-art/ts-common/core/exceptions/exceptions';
import { ModuleFE_Thunderstorm } from '@nu-art/thunderstorm-frontend/index';
import { resolveResolutionFunctionVariables } from '../../utils.js';
import { filterDuplicates, sortArray } from '@nu-art/ts-common';
export class Panel_HcsVariables extends Base_ResolutionFunctionEditorPanel {
    panelId = 'hcs-variables';
    deriveStateFromProps(nextProps, state) {
        let hcsVariables = filterDuplicates(resolveResolutionFunctionVariables(nextProps.resolutionFunctionItems));
        hcsVariables = sortArray(hcsVariables, (id) => ModuleFE_Variable.cache.unique(id)?._nameInLowercase);
        state.hcsVariables = hcsVariables;
        return state;
    }
    renderHeader = () => {
        return _jsx(_Fragment, { children: "HCS Variables" });
    };
    renderBody = () => {
        if (!this.state.hcsVariables.length)
            return _jsx("div", { className: 'not-found-title', children: "No variables found..." });
        return _jsx(_Fragment, { children: this.state.hcsVariables.map((_varId, index) => {
                const variable = ModuleFE_Variable.cache.unique(_varId);
                if (!variable)
                    throw new MUSTNeverHappenException(`variable with id ${_varId} not found`);
                const params = { id: _varId, searchItem: 'variables' };
                return _jsx("div", { onClick: () => ModuleFE_Thunderstorm.openUrl({ url: '/km/search-v2', params }, '_blank'), className: 'var-name', children: variable.name }, `var-${index}`);
            }) });
    };
}
//# sourceMappingURL=Panel_HcsVariables.js.map